import React from "react";
import { useTranslation } from "react-i18next";
import { EmailOutlined, Instagram } from "@mui/icons-material";
import "./Footer.css";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer id="contact" className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-contact">
              <h3 className="footer-title">{t("footer.contact")}</h3>
              <div className="contact-info">
                <div className="contact-row">
                  <div className="contact-item">
                    <EmailOutlined className="contact-icon" />
                    <a
                      href="mailto:nusexufrj@gmail.com"
                      className="contact-link"
                    >
                      nusexufrj@gmail.com
                    </a>
                  </div>
                  <div className="contact-item">
                    <Instagram className="contact-icon" />
                    <a
                      href="https://instagram.com/nusex.museunacional"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      @nusex.museunacional
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-address">
              <h3 className="footer-title">{t("footer.address")}</h3>
              <div className="address-text">
                Sala 14 - Prédio Administrativo Campus de Pesquisa e Ensino Av.
                Bartolomeu de Gusmão, 875 - São Cristóvão CEP: 20941-060 / Rio
                de Janeiro
              </div>
            </div>
          </div>

          <div className="footer-right">
            <div className="directions-section">
              <button
                onClick={() =>
                  window.open(
                    "https://ppgas.museunacional.ufrj.br/noticias/como-chegar-ao-ppgasmn",
                    "_blank"
                  )
                }
                className="directions-button"
              >
                {t("footer.howToGetHere")}
              </button>
            </div>

            <div className="footer-partners">
              <div className="partners-logos">
                <a
                  href="https://www.gov.br/cnpq/pt-br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="logo-link"
                >
                  <img src="/cnpq.png" alt="CNPq" className="partner-logo" />
                </a>
                <a
                  href="https://museunacional.ufrj.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="logo-link"
                >
                  <img
                    src="/mn.png"
                    alt="Museu Nacional"
                    className="partner-logo"
                  />
                </a>
                <a
                  href="https://ufrj.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="logo-link"
                >
                  <img src="/ufrj.png" alt="UFRJ" className="partner-logo" />
                </a>
                <a
                  href="https://www.gov.br/capes/pt-br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="logo-link"
                >
                  <img src="/capes.png" alt="CAPES" className="partner-logo" />
                </a>
                <a
                  href="https://ppgas.museunacional.ufrj.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="logo-link"
                >
                  <img src="/ppgas.png" alt="PPGAS" className="partner-logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <p className="copyright-text">
            {t("footer.madeBy")}{" "}
            <button
              onClick={() => {
                navigator.clipboard.writeText("marinatto.gustavo@gmail.com");
                // You could add a toast notification here if desired
              }}
              className="copyright-email"
              title={t("footer.copyEmail")}
            >
              marinatto.gustavo@gmail.com
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
